import { NgModule } from '@angular/core';

import zhCN from './languages/zh-CN';

import { LXLIB_LOCALE_SERVICE_PROVIDER } from './locale.service';
import { LXLIB_LOCALE } from './locale.tokens';

@NgModule({
  providers: [{ provide: LXLIB_LOCALE, useValue: zhCN }, LXLIB_LOCALE_SERVICE_PROVIDER],
})
export class LxlibLocaleModule {}
